<template>
  <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile">
    <NavBar />
      <div class="block block__challenges">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <section class="d-flex wrapper" v-else>
      <SidebarChallenges />
      <div class="block block__challenges">
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </section> 
  <!-- //ROUTER IF DESKTOP -->
</template>



<script>
import SidebarChallenges from '../../module/sidebar/SidebarChallenges'
import { mapGetters } from 'vuex'
import CatMixin from './CatMixin'
import NavBar from '../../module/Navbar'
import utils from '../../Utils'


export default {
  name:"challenges",
    components:{
        SidebarChallenges,
        NavBar
    }, 
    mixins: [
      CatMixin
    ],       
  data () {
    return {
        transition:null,
        isMobile:false,
    }
  },
  computed: {
    ...mapGetters([
      'getPageTransition',
    ])
  },
  created (){
    this.transition = this.getPageTransition;
    this.isMobile = utils.isMobile();
  },  

  methods : {
  },
};
</script>
